// The API stores a match key as one denormalized string, `"{slug}:{raw_value}"`.
// Both the API spec and the MatchKey model cap it at 255 characters.
export const MATCH_KEY_MAX_LENGTH = 255;

const SOURCE_VALUE_SEPARATOR = ':';

export function composeMatchKey(source: string, value: string) {
  return `${source.trim()}${SOURCE_VALUE_SEPARATOR}${value.trim()}`;
}

// Raw external identifiers may themselves contain colons, so only the first one
// separates the source slug from the value.
export function parseMatchKey(key: string) {
  const separatorIndex = key.indexOf(SOURCE_VALUE_SEPARATOR);

  if (separatorIndex === -1) {
    return { source: '', value: key.trim() };
  }

  return {
    source: key.slice(0, separatorIndex).trim(),
    value: key.slice(separatorIndex + 1).trim(),
  };
}

export function isValidMatchKey(source: string, value: string) {
  const hasSource = source.trim().length > 0;
  const hasValue = value.trim().length > 0;
  const isWithinLengthLimit =
    composeMatchKey(source, value).length <= MATCH_KEY_MAX_LENGTH;

  return hasSource && hasValue && isWithinLengthLimit;
}
